import React from 'react'

import { Chip } from '@mui/material'

export type StatusSeverity = 'success' | 'info' | 'warning' | 'error' | 'default'

type Props = { label: string; severity: StatusSeverity }

// Outlined when there is nothing to say, filled when there is, so a row of these scans by colour.
const StatusChip = ({ label, severity }: Props) => (
  <Chip
    color={severity}
    label={label}
    size="small"
    sx={{ fontWeight: 700, letterSpacing: '0.03em' }}
    variant={severity === 'default' ? 'outlined' : 'filled'}
  />
)

export default StatusChip
